import * as React from 'react';

import LectureApplicationContainer from '../../containers/LectureApplication';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 受講申請画面
 * @param props
 */
const LectureApplication: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('LectureApplication_0001')} />
			<LectureApplicationContainer {...props} />
		</>
	);
};

export default LectureApplication;



// WEBPACK FOOTER //
// ./src/pages/personal/LectureApplication.tsx